import { render, staticRenderFns } from "./BdBlock.vue?vue&type=template&id=d9fd803a&"
import script from "./BdBlock.vue?vue&type=script&lang=js&"
export * from "./BdBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports